import React from "react";
import About from "./components/About.js";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";


class App extends React.Component{
  render(){
      return(
        <div id="nav">
          <Navbar />
      
          <About />
          <Skills />
          <Projects />
          <Contact />
          <footer style={{backgroundColor:'#', marginLeft:"100px", marginBottom:"30px"}}>made with ♡ by michelle!</footer>
          </div>
          
      );
  }
}

export default App;